module.exports = __webpack_public_path__ + "static/img/heat-treatmentE.eec37cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heat-treatmentE.png
// module id = /HKS
// module chunks = 1